module.exports = __webpack_public_path__ + "img/shape-11.023c17c1.png";